module.exports = __webpack_public_path__ + "static/img/3.478ab6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.svg
// module id = BA8d
// module chunks = 12